/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { Text, TextLink, Container } from "@carrotfertility/carotene"
import { useCurrentUser } from "../../context/user/UserContext"
import { FormattedMessage } from "react-intl"

export function VerifyOtherEmailMessage(): JSX.Element {
  const { personalEmail } = useCurrentUser()

  return (
    <Container stack={"small"}>
      <Text color="black60" size="small">
        <FormattedMessage
          defaultMessage="If you'd like us to reply at {personalEmail}, verify it in <link>Account settings</link>."
          values={{
            personalEmail: personalEmail,
            link: (linkContent) => <TextLink to="/account#email-addresses">{linkContent}</TextLink>
          }}
        />
      </Text>
    </Container>
  )
}
